<template>
  <div class="nx-searcher-selection" :class="{ grabbing }">
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-toolbar class="nx-search-toolbar nx-heading--level-1 pt-1" color="transparent" flat>
        <v-toolbar-title>{{ $t('message.searcher.selection') }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <nx-list
        ref="list"
        :bulk="false"
        :items="value"
        :sortable="sortable"
        :grabbing="grabbing"
        :image-resolver-function="imageResolver"
        hide-chips
        hide-flag
        selection
        selectable
      >
        <template #item-actions="{ item }">
          <v-layout row fill-height align-center>
            <v-icon @click.capture.stop="$emit('click:remove', item.id)">delete</v-icon>
          </v-layout>
        </template>
      </nx-list>
    </template>
    <template v-else>
      <v-expansion-panel>
        <v-expansion-panel-content ref="panel">
          <template slot="header">
            <v-toolbar class="nx-search-toolbar nx-heading--level-1 pt-1" color="transparent" flat>
              <v-toolbar-title>
                <v-icon class="hidden-md-and-up" color="info">list_alt</v-icon>
                <span class="nx-searcher-selection-title"></span>{{ $t('message.searcher.selection') }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <nx-list
            ref="list"
            :bulk="false"
            :items="value"
            :sortable="sortable"
            :grabbing="grabbing"
            hide-chips
            hide-flag
            selection
            selectable
          >
            <template #item-actions="{ item }">
              <v-layout row fill-height align-center>
                <v-icon @click.capture.stop="$emit('click:remove', item.id)">delete</v-icon>
              </v-layout>
            </template>
          </nx-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </div>
</template>

<script>
import Sortable from 'sortablejs';
import difference from 'lodash/difference';
import { move } from '@/utils';
import List from './components/SortableList';
import NxList from '@/components/list/List';
import { fetchEntityListImage } from '@/modules/entity/utils';

export default {
  name: 'nx-searcher-selection',
  components: {
    NxList,
    [List.name]: List,
  },
  props: {
    value: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    sortable: {
      type: Boolean,
    },
  },
  data() {
    return {
      grabbing: false,
    };
  },
  methods: {
    onDelete(entity) {
      this.$emit('change', difference(this.value, [entity]));
    },
    onChange(event) {
      const diff = event.oldIndex - event.newIndex;
      if (diff < 0) {
        // Move down
        this.$emit('change', move(this.value, event.oldIndex, event.newIndex + 1));
      } else {
        // Move up
        this.$emit('change', move(this.value, event.oldIndex, event.newIndex));
      }
    },
    async imageResolver({ id, type }) {
      return fetchEntityListImage(id, type);
    },
  },
  watch: {
    value(val) {
      // Auto open the results panel when a new item is selected (mobile only)
      if (val.length > 0
        && this.$refs.panel
        && this.$refs.panel.isActive === false) {
        this.$refs.panel.onHeaderClick();
      }
    },
  },
  mounted() {
    this.sortablejs = Sortable.create(this.$refs.list.$el, {
      handle: '.nx-list-item-image',
      onUpdate: this.onChange,
      onStart: () => {
        this.grabbing = true;
      },
      onEnd: () => {
        this.grabbing = false;
      },
    });
  },
};
</script>

<style lang="stylus">
@import '../../../assets/stylus/variables.styl'

.nx-searcher-selection {
  background-color: #e9e9f2;
  width: 100%;
  height: 100%;
  padding: 0 30px 0 15px;

  @media $sm-and-down {
    padding: 0 20px;
  }

  @media $xs-only {
    padding: 0 10px;
  }

  .v-toolbar__title {
    font-size: 18px;
    letter-spacing: 0;
  }

  .v-toolbar__content {
    height: 34px !important;
    margin-bottom: 4px;
    margin-top: 10px;
    padding: 0;
    @media $sm-and-down {
      height: 40px !important;
      margin: 0;
    }
  }

  .v-expansion-panel {
    box-shadow: none;
  }

  .v-expansion-panel__header {
    padding: 0;
    margin: 0;
  }

  .v-expansion-panel__header__icon {
    .v-icon {
      color: $info !important;
    }
  }

  @media $sm-and-down {
    &-title {
      margin-left: 8px;
    }
  }

  &.grabbing * {
    cursor: grabbing !important;
  }
  .sortable-ghost {
    cursor: grabbing !important;
    &.nx-list-item.selection {
      outline: 1px solid $secondary;
    }
  }
  .sortable-element {
    cursor: grab !important;
  }
}
</style>
